import React from 'react';
import PropTypes from 'prop-types';
import SidebarDesktop from './SidebarDesktop';
import SidebarMobile from './SidebarMobile';

function Drawer({ isOpen, dismissPanel }) {
  return (
    <>
      <SidebarMobile isOpen={isOpen} dismissPanel={dismissPanel} />
      <SidebarDesktop />
    </>
  );
}

Drawer.defaultProps = {
  isOpen: false,
};

Drawer.propTypes = {
  isOpen: PropTypes.bool,
  dismissPanel: PropTypes.func.isRequired,
};

export default Drawer;
